import { HowToVideo, HowToVideosRequest } from '../../services/cellcast.type'
import axios from 'axios'
import { ENV } from '../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL

export class HowToVideosService {
  private static readonly ENDPOINT = 'how-to-videos'

  private static getHeaders() {
    const token = localStorage.getItem('token')
    return {
      'Authorization': token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json'
    }
  }

  /**
   * Fetch all how-to videos with optional filtering
   */
  static async getVideos(params: HowToVideosRequest = {}) {
    try {
      const response = await axios.get(`${API_URL}/${this.ENDPOINT}`, {
        params: {
          search: params.search || '',
          category: params.category || '',
          page: params.page || 1,
          size: params.size || 20,
          isActive: params.isActive !== undefined ? params.isActive : true
        },
        headers: this.getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error fetching how-to videos:', error)
      throw error
    }
  }

  /**
   * Get a single video by ID
   */
  static async getVideoById(id: string) {
    try {
      const response = await axios.get(`${API_URL}/${this.ENDPOINT}/${id}`, {
        headers: this.getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error fetching video by ID:', error)
      throw error
    }
  }

  /**
   * Create a new how-to video (Admin only)
   */
  static async createVideo(videoData: Omit<HowToVideo, '_id' | 'createdAt' | 'updatedAt'>) {
    try {
      const response = await axios.post(`${API_URL}/${this.ENDPOINT}`, videoData, {
        headers: this.getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error creating video:', error)
      throw error
    }
  }

  /**
   * Update an existing how-to video (Admin only)
   */
  static async updateVideo(id: string, videoData: Partial<HowToVideo>) {
    try {
      const response = await axios.put(`${API_URL}/${this.ENDPOINT}/${id}`, videoData, {
        headers: this.getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error updating video:', error)
      throw error
    }
  }

  /**
   * Delete a how-to video (Admin only)
   */
  static async deleteVideo(id: string) {
    try {
      const response = await axios.delete(`${API_URL}/${this.ENDPOINT}/${id}`, {
        headers: this.getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error deleting video:', error)
      throw error
    }
  }

  /**
   * Toggle video active status (Admin only)
   */
  static async toggleVideoStatus(id: string, isActive: boolean) {
    try {
      const response = await axios.patch(`${API_URL}/${this.ENDPOINT}/${id}/status`, 
        { isActive }, 
        { headers: this.getHeaders() }
      )
      return response.data
    } catch (error) {
      console.error('Error toggling video status:', error)
      throw error
    }
  }

  /**
   * Reorder videos (Admin only)
   */
  static async reorderVideos(videoIds: string[]) {
    try {
      const response = await axios.patch(`${API_URL}/${this.ENDPOINT}/reorder`, 
        { videoIds }, 
        { headers: this.getHeaders() }
      )
      return response.data
    } catch (error) {
      console.error('Error reordering videos:', error)
      throw error
    }
  }

  /**
   * Get video categories
   */
  static async getCategories() {
    try {
      const response = await axios.get(`${API_URL}/${this.ENDPOINT}/categories`, {
        headers: this.getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error fetching video categories:', error)
      throw error
    }
  }
}